import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SwitcherComponent } from './switcher.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SwitcherComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [SwitcherComponent],
})
export class SwitcherModule {}
